import { createUseStyles } from 'react-jss';
import { GLOBAL_LETTER_SPACING } from '@/styles/themes/components';
export const useStyles = createUseStyles((theme) => ({
    container: {
        padding: 8,
        position: 'relative',
        outlineStyle: 'none',
        WebkitTapHighlightColor: 'transparent',
        marginRight: -8,
        cursor: 'pointer',
    },
    questionMark: {
        width: 22,
        height: 22,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.colors.textPrimary,
        cursor: 'pointer',
        '&[data-active="true"]': {
            color: theme.colors.brand,
        },
        '& svg': {
            width: 22,
            height: 22,
        },
        '& svg > path': {
            fill: 'currentColor',
        },
    },
    tooltipContainer: {
        cursor: 'auto',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        '&[data-position="top"]': {
            top: 22,
            transform: 'translateY(-100%)',
        },
        '&[data-position="bottom"]': {
            bottom: -2,
            transform: 'translateY(100%)',
        },
    },
    tooltip: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 1,
        '&[data-position="top"]': {
            flexDirection: 'column',
        },
        '&[data-position="bottom"]': {
            flexDirection: 'column-reverse',
        },
    },
    tooltipBody: {
        backgroundColor: theme.colors.white,
        padding: '8px 10px',
        borderRadius: 12,
        boxShadow: theme.elevations[2],
        width: 'max-content',
        letterSpacing: GLOBAL_LETTER_SPACING,
        fontSize: 14,
        textAlign: 'center',
        color: theme.colors.black,
    },
    tooltipArrow: {
        fill: theme.colors.white,
        '& path': {
            fill: theme.colors.white + '!important',
        },
        margin: '-0.2px 0',
        '&[data-position="bottom"]': {
            transform: 'rotate(180deg)',
        },
    },
}), { name: 'info-tooltip' });
